<!-- TEMPLATE -->
<template>
  <div :class="deanSectionDividerClass">
    <span class="dean-section-divider-content" @click="toggleCollapse">
      <span class="accordion-label">{{ label }}</span>
      <span
              class="action"
              v-if="buttons">
        <div
                v-for="button in buttons"
                class="action-button"
                :key="button.name">
          <dean-tooltip
                  class="action-button-inner"
                  @click.native="buttonClicked(button)">
            <dean-icon
                    slot="activator"
                    class="action-button-inner-icon"
                    :glyph="button.icon">
            </dean-icon>
            {{ button.label }}
          </dean-tooltip>
        </div>
      </span>
      <dean-icon class="dean-icon" :class="{collapsed: showCollapse}" :glyph="goDownIcon" height="20">
        Open
      </dean-icon>
    </span>
    <collapse-transition>
      <div v-show="showCollapse">
        <slot></slot>
      </div>
    </collapse-transition>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';

  // COMPONENTS
  import {
    deanTooltip,
    goDownIcon,
  } from '@deanone/dean-components';
  import deanIcon from './deanIcon.vue';
  import {CollapseTransition} from 'vue2-transitions';

  @Component({
    components: {
      deanIcon,
      deanTooltip,
      CollapseTransition,
    },
  })

  export default class deanAccordion extends Vue {
    // PROPS
    @Prop({default: false}) sidemenu!: boolean;
    @Prop({default: Array}) buttons!: any[];
    @Prop() small!: boolean;
    @Prop() label!: string;
    public goDownIcon: object = goDownIcon;
    private showCollapse: boolean = false;

    // COMPUTED
    get deanSectionDividerClass() {
      let value = 'dean-section-divider';
      if (this.sidemenu) value += ` dean-section-divider-sidemenu`;
      if (this.small) value += ` dean-section-divider-small`;
      return value;
    }

    // METHOD
    buttonClicked(data: any) {
      this.$emit('button-click', data);
    }

    toggleCollapse() {
      this.showCollapse = !this.showCollapse;
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

  /* Import */
  @import '~@deanone/dean-components/src/scss/vars';

  // DEAN SECTION DIVIDER
  .dean-section-divider {
    padding: 5px 10px 5px 10px;
    width: 100%;

    .dean-icon {
      fill: $color-dark-shade-4;
      transition: all 0.2s;
      &.collapsed {
        transform: rotate(180deg);
      }
    }

    .dean-section-divider-content {
      transition: all 0.3s;

      &:hover {
        cursor: pointer;
        background-color: $color-light-shade-4;
      }
    }

    > span {
      position: relative;
      @include display-flex();
      justify-content: space-between;
      align-items: flex-end;
      padding: 10px;
      text-align: left;
      text-transform: uppercase;
      font-weight: 700;
      font-style: italic;
      color: black;
      border-bottom: 1px solid var(--color-light-shade-2, $color-light-shade-2);

      &:after {
        position: absolute;
        bottom: 0px;
        content: '';
        min-width: 35px;
        min-height: 5px;
        background: var(--color-secondary, $color-secondary);
      }
    }
  }

  .dean-section-divider-small {
    > span {
      font-style: normal;
      font-size: 10pt;
    }
  }

  .dean-section-divider-sidemenu {
    > span {
      border-bottom: 1px solid var(--color-light, $color-light);
    }
  }

  .action {
    @include display-flex();

    .action-button {
      padding-left: 10px;

      .action-button-inner {
        height: 30px;
        width: 30px;
        padding: 5px;
        background: var(--color-light-shade-2, $color-light-shade-2);
        fill: var(--color-link, $color-link);
        @include border-radius(5px);
        cursor: pointer;
        transition: .8s;

        &:hover {
          fill: var(--color-link-shade-2, $color-link-shade-2);
          background: var(--color-light, $color-light);
        }

        .action-button-inner-icon {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
</style>
